module.exports = __webpack_public_path__ + "static/media/OrangeCard.7e12645e.svg";